export default __webpack_public_path__ + "static/media/product_card2_Cn.98fc9d1f.webp";